import { render, staticRenderFns } from "./RatePlanTable.vue?vue&type=template&id=f2c021d6&scoped=true&"
import script from "./RatePlanTable.vue?vue&type=script&lang=js&"
export * from "./RatePlanTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c021d6",
  null
  
)

export default component.exports